import env from "react-dotenv";
export const CONFIG_AKM = {
    // AKM_HOST: 'http://localhost:8015', // Server Localhost
    //    AKM_HOST: 'http://45.64.97.198:8015', // Server Develop
    AKM_HOST: process.env.REACT_APP_URL_AKM_BE, // Server production
    // AKM_HOST: "http://18.140.135.175:8015", // Server production

    AKM_LIST: "/akm/list",
    CBT_PROFIL_POST: "/akm/tambah",
    GET_SUBPROFIL_BY_IDPROFIL: "/akm/getSubProfilByIdProfil/",
    GET_KATEGORI_AKM: "/akm/kategori",
    GET_JADWAL_BY_IDPROFIL: "/jadwalcbt/getByIdProfil?idProfil=",
    GET_JADWAL_MAPEL: "/akm/jadwalMapel/",
    POST_ADD_SUBPROFIL: "/akm/subProfil/add",
    GET_PROFIL_NON_AKADEMIK_AKM: "akm/nonAkademik/",
    POST_PROFIL_NON_AKADEMIK_AKM: "akm/nonAkademik/add",
    GET_REPORT: "/akm/report",

    KELAS_GROUP_ALL: "/kelas/group",
    KELAS_ALL: "/kelas",
    KURIKULUM_GET_ALL: "/kurikulum",
    MAPEL_GET_BY_IDKELASGROUP: "/mapel/findByIdKelasGroup/",
    MAPEL_GET_BY_IDKELAS: "/mapel/findByIdKelas/",
    GET_SEKOLAH_BY_ID: "sekolah/findById/",

    GET_TIPE_SOAL: "/soal/tipeSoal",
    GET_INDIKATOR: "/indikator",
    BANK_SOAL_LIST: "/soal/list",
    BANK_SOAL_POST: "/soal/add",
    POST_UPLOAD_HISTORY_ID: "soal/uploadHistory",
    POST_SOAL_DETAIL_AKM: "/soal/addSoalDetailAkm",
    GET_SOAL_DETAIL_AKM_BY_IDBANKSOAL: "/soal/findSoalDetailAkmByIdBankSoal?idBankSoal=",

    GET_ROLE: "/menus/getRoles",
    GET_USER_BY_ROLE: "/menus/userByRole?idRole=",
    GET_MENUS_BY_ROLE: "/menus/getMenuRole?idRole=",
    POST_ADD_SYS_MENU: "/menus/add/",

    // SNMPTN
    SEKOLAH_SMA_SEDERAJAT: "/snmptn/sekolah/",
    SEKOLAH_SEARCH_BY_LIKE: "/snmptn/sekolahlikename/",
    AKTFKAN_NONAKTIFKAN_SNMPTN: "/snmptn/onoffsnmptnsekolah/",

    // SNBP
    LIST_PRODI: "/prodi/list",

    // REPORT
    FETCH_JADWAL_CBT: "/jadwalcbt/getJadwalAkm/",
    GET_SEKOLAH_BY_ID_KELAS_KABUPATENKOTA: "/sekolah/findSekolahByKabupatenAndKelas/",

    // KELAS
    GET_KELAS_BY_ID_SEKOLAH: "/kelas/byIdSekolah/",

    // KELAS PARALEL
    FETCH_KELAS_PARALEL_BY_ID_SEKOLAH_KELAS: "/kelasparalel/byIdSekolahAndIdKelas/",

    // SISWA
    FETCH_SISWA_BY_ID_KELAS_PARALEL_AND_SEKOLAH: "siswa/byIdKelasParalelAndIdSekolah/",

    FETCH_SEKOLAH_BY_ID_KAB_AND_JENJANG: "/sekolah/api-public/findSekolahByIdKabJenjang",

    SUCCESS_ERROR_CODE: "EP-000",
};
